/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GroupParticipants = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        profile: {
    type: 'string',
    isRequired: true,
},
        primaryDepartment: {
    type: 'number',
    isRequired: true,
},
        titleId: {
    type: 'number',
    isRequired: true,
},
        isAdmin: {
    type: 'boolean',
    isRequired: true,
},
    },
};